// extracted by mini-css-extract-plugin
export default {"container":"Courier_container__6qELk","courierLabel":"Courier_courierLabel__fJYaN"};